import { LoaderFunctionArgs, redirect } from "react-router-dom";
import {
  checkIsAgent,
  checkIsProfileChecker,
  checkIsYp,
  getJwtClaims,
  authAxios as axios,
} from "shared-auth";
import { UserClaimTypes, UserManager, HALManager } from "core";
import { NOT_FOUND_FULL_PATH, VIEW_PIN_PATTERN } from "app/config/routes";
import { getApiUrl } from "services/UrlBuilder";

export function contactsRestrictionLoader() {
  if (checkIsAgent()) {
    throw new Response("Not Found", { status: 404 });
  }

  return null;
}

export function agenciesHelpPageRestrictionLoader() {
  if (checkIsYp()) {
    return null;
  }

  throw new Response("Not Found", { status: 404 });
}

export function socialMediaPageRestrictionLoader() {
  if (checkIsProfileChecker()) {
    return null;
  }

  throw new Response("Not Found", { status: 404 });
}

export async function viewPinRedirectPageLoader() {
  let viewPin = UserManager.getClaim(UserClaimTypes.viewPin);
  const user = getJwtClaims();

  try {
    if (!viewPin && user?.sub) {
      const { data } = await axios.get(
        getApiUrl(HALManager.getProfileByProfileIdUrl(user?.sub || ""))
      );

      viewPin = data.viewPin;
    }
  } catch (error) {
    console.error("Error fetching profile by user id", error);
  }

  return redirect(viewPin ? `/${viewPin}` : NOT_FOUND_FULL_PATH);
}

export function basePathLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const match = VIEW_PIN_PATTERN.exec(url.pathname);

  if (match) {
    return redirect(`/${match[0]}`);
  }

  throw new Response("Not Found", { status: 404 });
}

export function viewPinPageLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);

  if (VIEW_PIN_PATTERN.test(url.pathname)) {
    return null;
  }

  throw new Response("Not Found", { status: 404 });
}
